import type { SxProps } from "@mui/material/styles";
import type { TopUpStatus } from "@polifonia/interlude/billingConstants";
import type { muiTheme } from "@polifonia/theme";
import { theme } from "@polifonia/theme";
import { useTranslation } from "react-i18next";

import { Tag } from "@/components/Tag";
import { getStatusLabels } from "@/pages/billing/v2/tabs/usageDetails/utils";

const statusStyleMap: Record<TopUpStatus, SxProps<typeof muiTheme>> = {
  paid: {
    backgroundColor: theme.colors.green020,
    color: theme.colors.green060,
  },
  pending: {
    backgroundColor: theme.colors.yellow020,
    color: theme.colors.yellow060,
  },
  processing: {
    backgroundColor: theme.colors.blue020,
    color: theme.colors.blue060,
  },
  awaiting_payment: {
    backgroundColor: theme.colors.yellow010,
    color: theme.colors.yellow070,
  },
  failed: {
    backgroundColor: theme.colors.red020,
    color: theme.colors.red060,
  },
  cancelled: {
    backgroundColor: theme.colors.neutral010,
    color: theme.colors.neutral060,
  },
};

interface TopupStatusTagProps {
  status: TopUpStatus;
}

export const TopupStatusTag: React.FC<TopupStatusTagProps> =
  function TopupStatusTag({ status }) {
    const { t } = useTranslation();

    return (
      <Tag
        label={getStatusLabels(t)[status]}
        size="small"
        sx={statusStyleMap[status]}
      />
    );
  };
